import _get from "lodash/get";
import styled from 'styled-components';
import { baseTheme } from '~base-theme';
var ListItem = styled.li.withConfig({
  displayName: "ListItem",
  componentId: "wl7vmx-0"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme,
      colorValue = _ref.colorValue;
  return _get(theme, "base.colors." + colorValue, baseTheme.base.colors[colorValue]);
});
export default ListItem;